import { isStorefrontNext } from "helpers/environment-helpers";
import { hasInventoryEligibility } from "helpers/membership-helpers";
import { inventoryEligibilities, availabilityFilter, membershipLens } from "rtr-constants";

// If the user selects "Subscription" (shipsDefault) or "Browse all styles" (allStyles) simply refresh the page
// and allow the SSR to compute the correct grid and redux state (see next-grid-ssr-helpers.js).
// Otherwise we'd need to duplicate all this logic on the front end.
// We could add this in future if we need the SPA experience when toggling availability,
// however HEAP data indicates this is rarely done by our users. Let's keep this simple.
export const canRefreshGrid = (filter, gridMigratedToNext) => {
  return (
    (isStorefrontNext() || gridMigratedToNext) &&
    [availabilityFilter.shipsDefault, availabilityFilter.allStyles].includes(filter)
  );
};

export const refreshGrid = (filter, membershipState) => {
  const currentUrl = new URL(window.location.href);

  // For 1-swap users use the appropriate lens, for 2-swap and prospect users use unlimited
  if (hasInventoryEligibility(membershipState, inventoryEligibilities.rtr_update)) {
    currentUrl.searchParams.set("lens", membershipLens.RTRUpdate);
  } else {
    currentUrl.searchParams.set("lens", membershipLens.unlimited);
  }

  if (filter === availabilityFilter.allStyles) {
    currentUrl.searchParams.set("availableOnly", false);
  } else {
    // let it re-compute availableOnly with SSR
    currentUrl.searchParams.delete("availableOnly");
  }

  window.location.href = currentUrl.href;
};
